import React from 'react';
import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import { MdEdit as EditIcon } from 'react-icons/md';
import * as formatter from 'helpers/Formatter';

export const SavedUnits = ({ items, onEdit, onDelete, disabled, savedItemsProps }) => {
  const getUnitType = (item) => {
    const unitTypes = savedItemsProps.unitTypes;
    if (item.unit_type_id === undefined) return '';
    const unitType = unitTypes.find((unitType) => unitType.value === item.unit_type_id);
    return unitType && unitType.label;
  };

  const renderUnitDetails = (item) => {
    return (
      <div className="row">
        <div className="col-sm-4" style={{ paddingLeft: '0px' }}>
          <p>{item.sq_footage !== undefined && `${item.sq_footage} sq. ft.`}</p>
        </div>
        <div className="col-sm-4" style={{ paddingLeft: '0px' }}>
          <p>
            {item.market_rent !== undefined && `${formatter.formatMoney(item.market_rent)}/Month`}
          </p>
        </div>
        {item.rooms && item.rooms.length > 0 && (
          <div className="col-sm-4" style={{ paddingLeft: '0px' }}>
            <p>{item.rooms.length} rooms associated</p>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      {items.map((item, index) => {
        const unitNumber = item.unit_number ? `Unit ${item.unit_number}` : '';
        const name = `${unitNumber} - ${getUnitType(item)}`;
        return (
          <div
            id="mobile_card"
            key={`saved_unit_${index}`}
            style={{ paddingBottom: '0px', textTransform: 'capitalize' }}
          >
            {!disabled && onDelete && (
              <IconButton
                style={{ float: 'right', padding: '0px', height: '1px' }}
                onClick={() => onDelete(index)}
              >
                <DeleteIcon size={24} style={{ padding: '0px' }} />
              </IconButton>
            )}

            {!disabled && onEdit && (
              <IconButton
                style={{ float: 'right', padding: '0px', marginRight: '25px', height: '1px' }}
                onClick={() => onEdit(index)}
              >
                <EditIcon size={24} style={{ padding: '0px' }} />
              </IconButton>
            )}

            <div className="row">
              <div className="mobile_header">
                <p>{name}</p>
              </div>
              <div className="mobile_subheader">{renderUnitDetails(item)}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
